import EditTruckModule from 'modules/Admin/trucks/EditTruck'

function EditTruckPage() {
  return (
    <div data-testid="adminEditTruckPage">
      <EditTruckModule />
    </div>
  )
}

export default EditTruckPage
